import React from 'react';
import css from './GuestField.module.css'; // Using CSS modules
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

const GuestAField = props => {
  const {
    className,
    setAdults,
    handleIncrement,
    adults,
    handleDecrement,
    kids,
    setKids,
    infants,
    setinfants,
    hideGuestAndDogField,
    clearGuestAndDogField,
    searchPageWithMap,
    isAnyGuestOrDogSelected,
  } = props;

  return (
    <div
      className={classNames(css.counterBox, className, searchPageWithMap && css.searchPageWithMap)}
    >
      <div className={css.counterRow}>
        <span className={css.label}>
          <FormattedMessage id="Searchfilter.adults" />
          <div className={css.subLabel}>12 and older</div>
        </span>
        <div className={css.counterControls}>
          <button
            type="button"
            onClick={() => handleDecrement(setAdults, 'adults', adults)}
            className={css.button}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#3f1113" />
              <path d="M12 16H20" stroke="#3f1113" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </button>
          <span className={css.value}>{adults}</span>
          <button
            type="button"
            onClick={() => handleIncrement(setAdults, 'adults', adults)}
            className={css.button}
          >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#3f1113" />
              <path d="M16 12V20M20 16H12" stroke="#3f1113" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>

      <div className={css.counterRow}>
        <span className={css.label}>
          <FormattedMessage id="Searchfilter.kids" />
          <div className={css.subLabel}>0 to 11</div>
        </span>
        <div className={css.counterControls}>
          <button
            type="button"
            onClick={() => handleDecrement(setKids, 'kids', kids)}
            className={css.button}
          >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#3f1113" />
              <path d="M12 16H20" stroke="#3f1113" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <span className={css.value}>{kids}</span>
          <button
            type="button"
            onClick={() => handleIncrement(setKids, 'kids', kids)}
            className={css.button}
          >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#3f1113" />
              <path d="M16 12V20M20 16H12" stroke="#3f1113" strokeLinecap="round" />
            </svg>
          </button>
        </div>
      </div>

      <button
        type="button"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (hideGuestAndDogField) {
            hideGuestAndDogField();
          }
        }}
        className={css.closeBtn}
      >
        Close
      </button>
      {/* <div className={css.counterRow}>


      <div className={css.counterRow}>

        <span className={css.label}>
          <FormattedMessage id="Searchfilter.infants" />
        </span>
        <div className={css.counterControls}>
          <button
            type="button"
            onClick={() => handleDecrement(setinfants, 'infants', infants)}
            className={css.button}
          >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#3f1113" />
              <path d="M12 16H20" stroke="#3f1113" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <span className={css.value}>{infants}</span>
          <button
            type="button"
            onClick={() => handleIncrement(setinfants, 'infants', infants)}
            className={css.button}
          >
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
              <circle cx="16" cy="16" r="15.5" fill="white" stroke="#3f1113" />
              <path d="M16 12V20M20 16H12" stroke="#3f1113" strokeLinecap="round" />
            </svg>
          </button>
        </div>

      </div> */}
      {/* <div className={css.actions}>
        <div className={css.twoButton}>
          <button type='button' onClick={() => clearGuestAndDogField()} className={css.clearButton}>
            <FormattedMessage id="Searchfilter.clear" />
          </button>
          <button type='button' onClick={() => hideGuestAndDogField()} className={css.cancelButton}>
            <FormattedMessage id="Searchfilter.cancel" />
          </button>
        </div>
        <button type='button' onClick={() => hideGuestAndDogField()} className={css.applyButton}>
          <FormattedMessage id="Searchfilter.apply" />
        </button>
      </div> */}
    </div>
  );
};

export default GuestAField;
